import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  AppConfigsList: lazyNamed(() => import('./pages/AppConfigsList'), 'AppConfigsList'),
  AppConfigDetails: lazyNamed(() => import('./pages/AppConfigDetails'), 'AppConfigDetails'),
  AdConfigForm: lazyNamed(() => import('./pages/AdConfigForm'), 'AdConfigForm'),
  AppConfigForm: lazyNamed(() => import('./pages/AppConfigForm'), 'AppConfigForm'),
  ThirdPartyWebsitesList: lazyNamed(() => import('./pages/ThirdPartyWebsitesList'), 'ThirdPartyWebsitesList'),
  ThirdPartyTagForm: lazyNamed(() => import('./pages/ThirdPartyTagForm'), 'ThirdPartyTagForm'),
};
